import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, Team, Pricing, WhyUs, Process, NewsletterSection, Offers, Categories, Mission, Partners, HomeBanner, HomeCars, HomeSearch, PortfolioSection } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>

      <Home />          {/* Hero Section: Introduction to the website with a call-to-action */}
      <HomeSearch />    {/* Search Bar: Allows users to search for cars */}
      <About />         {/* About Section: Provides background information about the company */}
      <Counter />       {/* Counter Section: Displays important statistics or achievements */}
      <Categories />    {/* Categories Section: Shows popular car categories */}
      <HomeCars />      {/* HomeCars Section: Displays featured or popular cars */}
      <WhyUs />         {/* WhyUs Section: Explains why users should choose this business */}
      <Offers />        {/* Offers Section: Highlights special offers or deals */}
      <Services />      {/* Services Section: Lists the services offered by the business */}
      <Testimonials />  {/* Testimonials Section: Displays client reviews and testimonials */}
      <Team />          {/* Meet the team section introducing team members */}
      <Process />       {/* Process Section: Outlines the workflow or steps involved */}
      <Mission />       {/* Mission Section: Displays the mission and vision of the company */}
      <Pricing />       {/* Pricing Section: Shows pricing plans for various services */}
      <PortfolioSection /> {/* PortfolioSection: Showcases completed projects or portfolio */}
      <HomeBanner />    {/* HomeBanner Section: Promotional banner or call-to-action */}
      <Blogs />         {/* Blogs Section: Displays the latest blog posts */}
      <Partners />      {/* Partners Section: Shows logos of partners */}
      <NewsletterSection /> {/* NewsletterSection: Allows users to subscribe to a newsletter */}
    
    </div>
  )
}

export default HomePage;